import React from 'react';
import LaunchIcon from '@material-ui/icons/Launch';
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
import { Gps } from '../../pages/arc/models/arc-epi-props';
import { buttonStyles } from '../constants/theme/styles/components/buttonstyles';
import { TcsmModal } from './tcsm-modal';
import { WysiwygWithReactLink } from './wysiwyg-with-react-link';
import { ExternalLink } from './external-link-modal';
import { EventType, RegisterClick, RegisterLinkClick } from '../helpers/analytics-helper';

export interface Props {
	content: Gps;
}

export const GuidedProcessSupport = (props: Props) => {

	const buttonClasses = buttonStyles();
	const [open, setOpen] = React.useState(false);
	const [selectedItem, setSelectedItem] = React.useState(0);


	const handleClose = () => {
		setOpen(false);
	};

	const onLinkClick = (idx: number) => {
		setSelectedItem(idx);
		setOpen(true);
	};

	const currentModalItem = props.content?.gpsItems && props.content?.gpsItems[selectedItem];
	return (
		<>
			<div className='rich-text'>
				<h3>{props.content?.title}</h3>
				{props.content?.gpsItems?.map((a, idx) => {
					return (
						<div key={idx}>
							{
								a.externalUrl ?
									<>
										<p>
											<ExternalLink iconRight newWindow linkIcon={<LaunchIcon />} linkText={a.linkText} linkUrl={a.externalUrl?.originalString ? a.externalUrl?.originalString : a.externalUrl} onClickHandler={() => { RegisterClick(EventType.GpsClick, a.linkText, a.externalDownloadLink || window.location.href); }} />
										</p>
									</>
									:
									<>
										<p >
											<button className={`${buttonClasses.linkButton} sidebar-link`} type='button' onClick={() => { onLinkClick(idx); RegisterClick(EventType.GpsClick, a.linkText, a.externalDownloadLink || window.location.href); }}>
												<svg className='icon' aria-hidden='true' focusable='false'>
													<use xmlnsXlink='http://www.w3.org/2000/xlink' xlinkHref='#feed-icon' />
												</svg>
												<span>{a.linkText}</span>
											</button>
										</p>
									</>
							}
						</div>
					);
				})}
			</div>
			<TcsmModal
				open={open}
				handleClose={handleClose}
			>
				<>
					<h3 className='modal-content-title'>{currentModalItem?.modalTitle}</h3>
					<WysiwygWithReactLink content={currentModalItem?.modalDescription} />
					{currentModalItem?.externalDownloadLink && currentModalItem?.downloadText && <a className={`${buttonClasses.linkButton} modal-file-link`} href={currentModalItem?.externalDownloadLink} target='_blank' rel="noreferrer" onClick={() => { RegisterLinkClick(currentModalItem?.downloadText, currentModalItem?.externalDownloadLink); }}><PictureAsPdfIcon /><span>{currentModalItem?.downloadText}</span></a>}
				</>
			</TcsmModal>
		</>
	);
};